module.exports = __webpack_public_path__ + "static/media/LAP AND EBOOK.a57cd623.png";